var map = {
	"./answer.json": "Qusd",
	"./cities.json": "Kcxh",
	"./survey.json": "qBLu",
	"./survey.test.json": "7EiC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ZLN";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.json$
// module id = 1ZLN
// module chunks = 1